// @ts-nocheck

import { concat, filter } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { HelpLink, SectionHeader } from '../../../generic'
import {
  EmarCautionaryInstructions,
  EmarMedicationStartEndSection,
  EmarNextStepButton
} from '../components'

interface AddMedInstructionsStepProps {
  errors: string[]
  fields: Record<string, any>
  emarRoundTimings: any[]
  editState: boolean
  formId: string
  formState: Record<string, any>
  goToNextStep: () => void
  resident: Record<string, any>
  setFormState: (key: string, value: any) => void
  validateFormFields: (callbacks: {
    onComplete: () => void
    onError: () => void
  }) => void
  mixpanel?: any // Add appropriate type
}

export default class AddMedInstructionsStep extends Component<AddMedInstructionsStepProps> {
  state = {
    editEmarMedication: false
  }

  stepErrors: string[] = []

  stepRef: HTMLDivElement | null = null

  setStepRef = (node: HTMLDivElement | null) => (this.stepRef = node)

  componentDidMount() {
    const { stepRef } = this
    const { mixpanel } = this.props

    if (stepRef) {
      stepRef?.scrollIntoView()
    }
    if (mixpanel) mixpanel.track('CO_emar_modal_completed_stock')
  }

  handleError = () => {
    if (this.stepRef) {
      this.stepRef?.scrollIntoView()
    }
  }

  handleNext = () => {
    const { fields, validateFormFields } = this.props

    if (!filter(fields.emarRoundsDetails, 'isChecked').length) {
      this.stepErrors = ['Medication Rounds is required']
      validateFormFields({
        onComplete: () => this.handleError(),
        onError: () => this.handleError()
      })
    } else {
      this.stepErrors = []
      validateFormFields({
        onComplete: () => this.onNext(),
        onError: () => this.handleError()
      })
    }
  }

  onNext = () => {
    const { goToNextStep, mixpanel } = this.props

    if (mixpanel) mixpanel.track('CO_emar_modal_completed_instructions')

    goToNextStep()
  }

  // Render sections

  renderStartEndSection = () => {
    const { stepErrors } = this
    const { errors, fields, formId, testId } = this.props

    return (
      <div
        style={styles.sectionContainer}
        data-testid={
          testId ? `${testId}-start-end-section` : 'start-end-section'
        }
      >
        <div style={styles.dosageWrapper}>
          <SectionHeader
            greyLine
            lineStyles={styles.sectionTitleLine}
            title="Dosage Instructions"
            titleStyles={styles.sectionTitle}
          />
          {/* {!this.state.editEmarMedication && (
            <Button
              variant="primary"
              onClick={() =>
                this.setState({
                  editEmarMedication: true,
                })
              }
            >
              Edit
            </Button>
          )} */}
        </div>
        <EmarMedicationStartEndSection
          {...this.props}
          errors={concat(stepErrors, errors)}
          fields={fields}
          formId={formId}
          /* editState={!this.state.editEmarMedication} */
        />
      </div>
    )
  }

  renderInstructionsSection = () => {
    const { fields, formId, resident, editState, testId } = this.props

    return (
      <div
        style={styles.sectionContainer}
        data-testid={
          testId ? `${testId}-instructions-section` : 'instructions-section'
        }
      >
        <SectionHeader
          greyLine
          lineStyles={styles.sectionTitleLine}
          title="Cautionary Instructions"
          titleStyles={styles.sectionTitle}
        />
        <EmarCautionaryInstructions
          fields={fields}
          formId={formId}
          resident={resident}
        />
        {!editState && (
          <div style={styles.footer}>
            <HelpLink supportLink="https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication" />
            <EmarNextStepButton handleNext={this.handleNext} />
          </div>
        )}
      </div>
    )
  }

  // Main render function

  render() {
    const { editState, testId } = this.props
    // Don't render wrapping styles for the Edit form
    return (
      <div
        style={editState ? {} : styles.container}
        data-testid={
          testId
            ? `${testId}-add-med-instructions-step`
            : 'add-med-instructions-step'
        }
      >
        {!editState && <div ref={this.setStepRef} style={styles.topSpacing} />}
        {this.renderStartEndSection()}
        {this.renderInstructionsSection()}
      </div>
    )
  }
}

const styles = {
  container: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: 960,
    padding: '0px 10px'
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 30
  },
  sectionContainer: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '30px',
    marginBottom: 3
  },
  sectionTitleLine: {
    marginBottom: 0
  },
  topSpacing: {
    height: 225
  },
  dosageWrapper: {
    display: 'flex'
  }
}
